import PlaceholderPage from "../components/PlaceholderPage";

function ColorbondColoursPage() {
  return (
    <PlaceholderPage
      title="Colorbond Fencing Colours Perth | Stag Fencing"
      description="Explore popular Colorbond fencing colours for Perth homes and businesses. Find a fence colour that suits your property, exterior and surrounding landscape."
      path="/resources/colorbond-colours"
    />
  );
}

export default ColorbondColoursPage;
